import {SingleEvent} from "#Shared/Lit/SingleEvent";
export {SingleEvent} from "#Shared/Lit/SingleEvent";

export {AttributePart, html, LitElement, noChange, nothing, Part, render,PropertyValues} from 'lit';
export {customElement} from 'lit/decorators';
import {AttributePart, html, LitElement, noChange, nothing, Part, render} from 'lit';
import {customElement, queryAll} from 'lit/decorators.js';
export {ref} from 'lit/directives/ref.js';
import {AttributePartInfo, Directive, directive, PartInfo, PartType} from "lit/directive.js";
import {getCommittedValue,insertPart,removePart,setChildPartValue,setCommittedValue} from "lit-html/directive-helpers.js";
import {LitElementBase} from "./LitElementBase";
export {live} from "lit-html/directives/live";
export {repeat} from "lit/directives/repeat.js";
export {LitElementBase} from "./LitElementBase";



export const customElementOnce=(tagName:string)=> (
    classOrDescriptor: any
)=>{
    if(window.customElements.get(tagName)!=null)
        return;

    window.customElements.define(tagName,classOrDescriptor as any);
}



export const isSingleExpression = (part: PartInfo) =>
    (part as AttributePartInfo).strings === undefined;





class LiveDirective extends Directive {
    constructor(partInfo: PartInfo) {
        super(partInfo);
        if (
            !(
                partInfo.type === PartType.PROPERTY ||
                partInfo.type === PartType.ATTRIBUTE ||
                partInfo.type === PartType.BOOLEAN_ATTRIBUTE
            )
        ) {
            throw new Error(
                'The `live` directive is not allowed on child or event bindings'
            );
        }
        if (!isSingleExpression(partInfo)) {
            throw new Error('`live` bindings can only contain a single expression');
        }
    }

    render(value: unknown) {
        return value;
    }

    update(part: any, [value]: any) {
        if (value === noChange || value === nothing) {
            return value;
        }
        const element = part.element;
        const name = part.name;

        // TODO (justinfagnani): This is essentially implementing a getLiveValue()
        // method for each part type. Should that be moved into the AttributePart
        // interface?
        if (part.type === PartType.PROPERTY) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (value === (element as any)[name]) {
                return noChange;
            }
        } else if (part.type === PartType.BOOLEAN_ATTRIBUTE) {
            if (!!value === element.hasAttribute(name)) {
                if(element.tagName == 'INPUT'&&(element.getAttribute('type').toLowerCase()=='radio'||
                    element.getAttribute('type').toLowerCase()=='checkbox'))
                {
                    (element as HTMLInputElement).checked=value;
                }

                return noChange;
            }
        } else if (part.type === PartType.ATTRIBUTE) {
            if(element.tagName=='SELECT')
            {
                (element as HTMLSelectElement).value=value;
            }
            if (element.getAttribute(name) === String(value)) {
                return noChange;
            }
        }

        if(part.type==PartType.PROPERTY)
        {
            if(element.tagName=='SELECT')
            {
                (element as HTMLSelectElement).value=value;
            }
        }

        if(element.tagName=='INPUT'&&(element.getAttribute('type').toLowerCase()=='radio'||
            element.getAttribute('type').toLowerCase()=='checkbox'))
        {
            (element as HTMLInputElement).checked=value;
        }
        // Resets the part's value, causing its dirty-check to fail so that it
        // always sets the value.
        setCommittedValue(part as any);
        return value;
    }
}





export function query(selector: string) {
    return function (target,propertyKey:string) {

        return {
            get: function () {
                return this.renderRoot.querySelector(selector);
            },
            set:undefined
        } as any

    };
}



export function renderInline(value:any,getRoot:boolean=false):Element
{
    let div=document.createElement('div');
    render(value,div);
    if(getRoot)
        return div;
    return div.firstElementChild;
}


function rncg(classes){
    let text='';
    if(classes==null||!(classes instanceof Object))
        return;

    let classNames=[];
    for(let className in classes)
    {
        let value:any=classes[className];
        if(value===null||value===false||value==='')
            continue;

        classNames.push(className);

    }
    return classNames.join(' ');
}

export function rnDispatchEvent(element:LitElementBase,eventName:string,args:any=null,bubbles:boolean=false)
{
    let ev=new CustomEvent(eventName,{detail:args,bubbles:bubbles,cancelable:true});
    element.dispatchEvent(ev);
    return ev;
}


export function rnIf(element)
{
    if(element == false || element == undefined)
        return '';
    return element;
}

export function rnsg(styles:Partial<CSSStyleDeclaration>):string{
    let text='';
    if(styles==null||!(styles instanceof Object))
        return '';

    for(let styleName in styles)
    {
        let value:any=styles[styleName];
        if(value===null||value===false||value==='')
            continue;

        text+=styleName.replace(/([A-Z])/g, '-$1').trim().toLowerCase()+':'+value+';';
    }
    return text;
}



